import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import webpushHelper, { isWebPushSupported, WEBPUSH_STATUS } from 'utils/webpushHelper';
import { hideModal } from 'actions/modalActions';
import PushNotificationWidget from 'components/PushNotificationWidget/PushNotificationWidget';
import PNDefaultView from './PNDefaultView.json';
import PNDeniedView from './PNDeniedView.json';
export class PushNotificationWrapperComponent extends React.Component {
    constructor(props) {
        super(props);
        this.handleNotifyFailure = (callBackProps) => {
            const extraParams = get(callBackProps, 'extraParams') || {};
            if (extraParams['hideModal']) {
                this.props.hideModal();
            }
            if (extraParams['permission'] === WEBPUSH_STATUS.DENIED) {
                this.setState({ permission: WEBPUSH_STATUS.DENIED });
            }
        };
        this.handleAllowNotify = (callBackProps) => {
            this.props.hideModal();
            const onSuccess = get(this.props.modal, 'modalProps.handleAllowNotify');
            if (onSuccess && typeof onSuccess === 'function') {
                onSuccess(callBackProps);
            }
        };
        this.state = {
            permission: (isWebPushSupported() && webpushHelper.getWebPushPermissionStatus()) || WEBPUSH_STATUS.DENIED
        };
    }
    render() {
        const { permission } = this.state;
        if (!isWebPushSupported() || permission === WEBPUSH_STATUS.GRANTED) {
            this.props.hideModal();
            return null;
        }
        let data;
        switch (permission) {
            case WEBPUSH_STATUS.DENIED:
                data = PNDeniedView;
                break;
            default:
                data = PNDefaultView;
                break;
        }
        const modalProps = get(this.props.modal, 'modalProps');
        const promptText = get(modalProps, 'promptText');
        return (<PushNotificationWidget data={data} promptText={promptText} onSuccess={this.handleAllowNotify} onFailure={this.handleNotifyFailure}/>);
    }
}
const mapDispatchProps = {
    hideModal
};
export default connect(null, mapDispatchProps)(PushNotificationWrapperComponent);
